import { render, staticRenderFns } from "./ProblemProcessAdd.form.vue?vue&type=template&id=57115f47&"
import script from "./ProblemProcessAdd.form.vue?vue&type=script&lang=js&"
export * from "./ProblemProcessAdd.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports